import { useTranslation } from 'next-i18next/pages';

import { ReactComponent as Check } from '@pflegia/ui/icons/check.svg';

import { MatchReason } from './get-match-reasons';

export interface MatchReasonsBlockProps {
  reasons: MatchReason[];
  formalLanguage?: boolean;
}

const MatchReasonsBlock: React.FC<MatchReasonsBlockProps> = ({ reasons, formalLanguage }) => {
  const { t } = useTranslation('jobDetails');

  if (!reasons.length) return null;

  return (
    <div
      data-testid='match-reasons-block'
      className='-mx-6 border-b border-gray-200 bg-white px-4 py-5 sm:mx-0 sm:mb-2 sm:rounded-2xl sm:border-none lg:mb-4 lg:px-12'>
      <p className='mb-4 text-xs font-bold tracking-widest text-gray-500 uppercase lg:mb-3'>
        {t(`matchReasons.title.${formalLanguage ? 'formal' : 'informal'}`)}
      </p>
      <ul className='flex flex-col gap-3 lg:gap-2.5'>
        {reasons.map(reason => (
          <li key={reason.key} className='flex items-center gap-3'>
            <span className='text-primary flex size-6 shrink-0 items-center justify-center rounded-full bg-blue-100 lg:size-5'>
              <Check className='size-4 lg:size-3.5' />
            </span>
            <span className='text-default text-base font-semibold'>{reason.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MatchReasonsBlock;
